export interface CrmDuplicateScanSummary {
  matches: unknown[];
  autoMerged: unknown[];
}

interface CrmContactDuplicateScanCardProps {
  result: CrmDuplicateScanSummary | null;
  error: string | null;
  isScanning: boolean;
  onScan: () => void;
}

export function CrmContactDuplicateScanCard({
  result,
  error,
  isScanning,
  onScan,
}: CrmContactDuplicateScanCardProps) {
  return (
    <div className="rounded-xl border border-[var(--color-border)] bg-[var(--color-card)] p-4">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-medium uppercase text-[var(--color-muted-foreground)]">Duplicate scan</p>
          <p className="mt-1 text-sm text-[var(--color-muted-foreground)]">
            Run the mounted dedup engine for this contact. 95%+ matches are auto-merged by the backend and remain undoable from merge history.
          </p>
        </div>
        <button
          type="button"
          onClick={() => { onScan(); }}
          disabled={isScanning}
          className="rounded-md border border-[var(--color-border)] px-3 py-1.5 text-xs font-medium text-[var(--color-foreground)] hover:bg-[var(--color-muted)] disabled:opacity-60"
        >
          {isScanning ? "Scanning..." : "Scan for duplicates"}
        </button>
      </div>
      {result ? (
        <p className="mt-3 text-xs text-[var(--color-muted-foreground)]">
          {result.matches.length} duplicate candidate{result.matches.length === 1 ? "" : "s"} found ·{" "}
          {result.autoMerged.length} auto-merged at 95%+ confidence. Review remaining candidates in CRM duplicates.
        </p>
      ) : null}
      {error ? (
        <p className="mt-3 text-xs text-[var(--color-destructive)]">{error}</p>
      ) : null}
    </div>
  );
}
